exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zoom-animation[data-v-70870881]{transform:scale(.8);transition:transform .3s ease-in-out}.modal.show.zoom-animation[data-v-70870881]{transform:scale(1)}", ""]);

// exports
